class ProductNotifyMe extends HTMLElement {
    onVariantChangeUnsubscriber = undefined;
    constructor() {
        super();
        this.variant = this.querySelector('[data-notify-variant]');
        this.email = this.querySelector('[data-notify-email]');
    }

    connectedCallback() {
        this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.notifyMe, (data) => {
            if (!data.form.checkValidity()) {
                data.form.reportValidity();
                return;
            } 
            this.buildData();
        })
    }

    disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
    }

    async buildData() {
        const url =  `${window.klaviyoVariables.api_url}${window.klaviyoVariables.company_id}`;
        const notifyBtn = this.querySelector('[data-type="notify-me"] span');
        if (!notifyBtn) return
        const data = {
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ['EMAIL'],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: `${this.email.value}`
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${this.variant.value}`
                        }
                    }
                }
            }
        }
        try {
            await fetch(url, {
                method: "POST",
                headers: {
                    "accept": "application/vnd.api+json",
                    "content-type": "application/vnd.api+json",
                    "revision": '2025-01-15',
                },
                body: JSON.stringify(data),
            })
            notifyBtn.innerText = window.notifyMe.success
        } catch (e) {
            notifyBtn.innerText = window.notifyMe.error
        }

    };
}
customElements.define('product-notify-me', ProductNotifyMe);
